<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="communication_schedule_master_list" class="elevation-1 mytable"
                dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Communication Schedule</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Communication Schedule</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.starttime" persistent-hint
                                                        label="Please Enter Start Time" type="time"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.endtime" persistent-hint
                                                        label="Please Enter End Time" type="time"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete color="#0F2027" dense rounded required
                                                        v-model="editedItem.day" :items="day_list" item-text="day"
                                                        item-value="id" label="Day" outlined persistent-hint
                                                        hint="Please Select Day" :rules="[(v) => !!v || 'required']" />

                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete color="#0F2027" dense rounded required
                                                        v-model="editedItem.usertype" :items="usertype_list"
                                                        item-text="name" item-value="id" label="User Type" outlined
                                                        :rules="[(v) => !!v || 'required']" />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete color="#0F2027" dense rounded required
                                                        v-model="editedItem.module" :items="module_list"
                                                        item-text="name" item-value="id" label="Module" outlined
                                                        :rules="[(v) => !!v || 'required']" />
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <div>
                        <v-btn color="warning" icon dark @click="deletecommunicationSchedule(item)">
                            <v-icon>mdi-delete-empty</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        // extraBreadcrumbItems: [
           
        //     { text: "Communication Schedule", disabled: true, href: "" },
        // ],
        // breadcrumbClass: "breadcrumb-style1",
        overlay: false,
        errorMsg: {
            starttime: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "Start Time",
                align: "left",
                sortable: false,
                value: "starttime",
            },
            {
                text: "End Time",
                align: "left",
                sortable: false,
                value: "endtime",
            },
            {
                text: "Day",
                align: "left",
                sortable: false,
                value: "day",
            },
            {
                text: "User Type",
                align: "left",
                sortable: false,
                value: "usertype",
            },
            {
                text: "Module",
                align: "left",
                sortable: false,
                value: "module",
            },

            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            {
                text: "Action",
                align: "left",
                sortable: true,
                value: "action",
            },
            {
                text: "Delete",
                align: "left",
                sortable: true,
                value: "delete",
            },

        ],
        communication_schedule_master_list: [],
        usertype_list: [],
        day_list: [],
        module_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            module: "",
            usertype: "",
            day: "",
            endtime: "",
            starttime: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            module: "",
            usertype: "",
            day: "",
            endtime: "",
            starttime: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Communication Schedule" : "Edit Communication Schedule";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        deletecommunicationSchedule(item) {
            if (!confirm("Are You Sure You Want To Delete This communication Schedule?")) return;
            const formData = {
                query_id: item.id,
            };
            axios
                .post("/CommunicationType/deleteCommunicationSchedule", formData)
                .then((res) => {
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "communication Schedule delete Successfully...!"); // show snackbar
                        this.onLoad();
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.delete_attach_load = false;
                    this.fetchNotices()
                });
        },
        editItem(item) {

            this.editedIndex = this.communication_schedule_master_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.editedItem.day = item.day_id; // Ensure that dropdowns get the correct IDs
            this.editedItem.usertype = item.usertype_id;
            this.editedItem.module = item.module_id;
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/CommunicationType/getCommunicationSchedule")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.communication_schedule_master_list = res.data.communication_schedule_master_list;
                        this.usertype_list = res.data.user_type_list;
                        this.day_list = res.data.day_list;
                        this.module_list = res.data.module_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/CommunicationType/editCommunicationSchedule", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {

                                Object.assign(this.communication_schedule_master_list[this.editedIndex], this.editedItem);
                                this.onLoad();
                            } else if (res.data.msg == "NA") {

                                this.showSnackbar("#b71c1c", "Communication Schedule Already Present!!!"); // show snackbar on error
                            }
                            this.showSnackbar("#4caf50", "Communication Schedule Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/CommunicationType/saveCommunicationSchedule", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {

                            this.communication_schedule_master_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "Communication Schedule Added Successfully..."); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.code == "NA") {

                            this.showSnackbar("#b71c1c", "Communication Schedule Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        },
        isValidated() {
            if (this.editedItem.starttime) {
                return true;
            } else {
                if (!this.editedItem.starttime) {
                    this.errorMsg.starttime = true;
                }

                return false;
            }
        }, // .....end of isValidated()

        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/CommunicationType/toggleCommunicationSchedule", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Communication Schedule Status Changed!"); // show snackbar
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
